<template>
  <div class="customer-select-content">
    <div v-if="isPublicPool" style="margin-bottom: 12px">
      <el-select
        v-model="customerTemplateId"
        class="customer-template-select"
        :options="customerTemplateList"
        placeholder="请选择模板"
        :props="{
          value: 'id',
          label: 'name'
        }"
      />
    </div>
    <div class="flex-center" style="gap: 10px">
      <el-input
        v-model="nameLike"
        clearable
        :placeholder="nameLikeTitle"
        :prefix-icon="Search"
        @clear="handleClearSearch"
        @input="handleSearchInput"
        @keydown.enter="handleEnterSearch"
      ></el-input>
      <DepartmentStaffSelect
        v-model:value="rangeValue"
        :department-staff-select-tab-type="rangeType"
        :placeholder="ownerPlaceholder"
        @clear="handleRangeClear"
        @typeChange="handleRangeTypeChange"
      />
    </div>
    <!-- 多选 -->
    <el-checkbox
      v-if="customerList.length"
      class="custom-checkbox data-list__item"
      :indeterminate="indeterminate"
      :model-value="selectAllStatus"
      style="margin-top: 12px"
      @click.native="handleSelectAll"
    >
      全选
    </el-checkbox>
    <!-- {{ params }} -->
    <el-scrollbar v-loading="loading" class="data-list">
      <div v-if="customerList.length">
        <el-checkbox
          v-for="customer in customerList"
          :key="customer[props.modalValueAlias.key]"
          class="custom-checkbox data-list__item"
          :disabled="isCheckDisabled(customer)"
          :model-value="
            Boolean(currSelectCustomerIds.includes(customer[props.modalValueAlias.key]))
          "
          @click.native="checkboxChange(customer)"
        >
          <!-- :checked="Boolean(currSelectCustomerIds.includes(customer[props.modalValueAlias.key]))" -->
          {{ customer[props.modalValueAlias.label] }}
        </el-checkbox>
      </div>
      <div v-else class="data-empty">暂无数据</div>
    </el-scrollbar>
    <!-- paging -->
    <el-pagination
      v-show="customerList.length && pageHelper.pageTotal > 1"
      :current-page.sync="pageHelper.currentPageNum"
      layout="prev, pager, next"
      :page-count="pageHelper.pageTotal"
      :page-size="pageHelper.pageSize"
      :pager-count="5"
      small
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script setup>
import {
  onMounted,
  onBeforeUnmount,
  ref,
  defineProps,
  watch,
  computed,
  defineEmits,
  getCurrentInstance,
  inject
} from 'vue'
import { getAiAnalyseBusinessDataList } from '@/api/index.js'
import { getClueTemplateList, getCustomerTemplateList } from '@/api/ai-board'
import { Search } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import DepartmentStaffSelect from '@/components/departmentStaffSelect.vue'
import xbb from '@xbb/xbb-utils'
// instance
const instance = getCurrentInstance().proxy
// emit
const emit = defineEmits(['update:modalValue'])
// props
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  },
  modelValue: {
    type: Array,
    require: true,
    default: () => []
  },
  modalValueAlias: {
    type: Object,
    default: () => ({
      label: 'name',
      key: 'id'
    })
  },
  limitCount: {
    type: Number,
    default: 200
  },
  businessType: {
    type: Number,
    default: 100,
    require: true
  }
})
// data
const customerType = inject('customerType', ref(0))
const title = inject('title', ref('客户'))
const nameLikeTitle = computed(() => {
  return `搜索${title.value}名称`
})
const templateId = inject('templateId', ref(''))
// 这里转换为数字，否则无法匹配label
const normalizeTemplateId = (val) => (val ? Number(val) : '')
const customerTemplateId = ref(normalizeTemplateId(templateId.value))
const customerTemplateList = ref([])
const isPublicPool = computed(() => customerType.value === 1)
const ownerPlaceholder = computed(() => (isPublicPool.value ? '选择前负责人' : '选择负责人'))
const customerList = ref([])
const loading = ref(false)
const pageHelper = ref({
  currentPageNum: 1,
  pageSize: 10,
  pageTotal: 0
})
const nameLike = ref('')
const rangeValue = ref('')
const rangeType = ref(1)
// computed
const mergeParams = computed(() => {
  const userRangePojoList = []

  if (rangeValue.value) {
    userRangePojoList[0] = {
      id: rangeValue.value,
      property: rangeType.value === 1 ? 'user' : 'dept'
    }
  } else if (props.params.user?.id) {
    userRangePojoList[0] = {
      id: props.params.user.userId,
      property: 'user'
    }
  } else if (props.params.dept?.id) {
    userRangePojoList[0] = {
      id: props.params.dept.id,
      property: 'dept'
    }
  }

  return {
    userRangePojoList
  }
})
// 当前渲染列表的数据id
const customerListId = computed(() => {
  return customerList.value.map((item) => item[props.modalValueAlias.key])
})
// 所有选中的数据
const selectCustomerList = computed({
  set(val) {
    emit('update:modalValue', val)
  },
  get() {
    return props.modelValue
  }
})
// 所有选中的所有数据id
const currSelectCustomerIds = computed(() => {
  return selectCustomerList.value.map((item) => item[props.modalValueAlias.key])
})
// 全选状态
const selectAllStatus = computed(() => {
  const pageIds = customerListId.value
  const selectedIds = currSelectCustomerIds.value

  if (!pageIds.length) return false

  return pageIds.every((id) => selectedIds.includes(id))
})
// 半选状态
const indeterminate = computed(() => {
  const pageIds = customerListId.value
  const selectedIds = currSelectCustomerIds.value

  const selectedCount = pageIds.filter((id) => selectedIds.includes(id)).length

  return selectedCount > 0 && selectedCount < pageIds.length
})
// watch
watch(
  () => mergeParams.value,
  (val = {}) => {
    val?.userRangePojoList?.length && onSearch()
  },
  {
    deep: true
  }
)
watch(
  () => selectCustomerList.value,
  (val) => {
    instance.$forceUpdate()
    console.log('🚀 watch ~ selectCustomerList.value:', val)
  },
  {
    deep: true
  }
)
watch(
  () => customerType.value,
  async (val) => {
    if (val === 1 && !customerTemplateList.value.length) {
      await getTheCustomerTemplateList()
    }
    onSearch()
  }
)
watch(
  () => customerTemplateId.value,
  () => {
    isPublicPool.value && onSearch()
  }
)
// methods
const getTemplateListApi = () => {
  // 区分线索公海池 和 客户公海池
  return props.businessType === 8000 ? getClueTemplateList : getCustomerTemplateList
}

const getTheCustomerTemplateList = () => {
  const request = getTemplateListApi()
  return request().then((res) => {
    customerTemplateList.value = xbb._get(res, 'result.dataList', [])
    if (!customerTemplateId.value && customerTemplateList.value.length) {
      const firstItem = customerTemplateList.value[0]
      customerTemplateId.value = firstItem.id
    }
  })
}
const toGetData = () => {
  const params = {
    ...mergeParams.value,
    businessType: props.businessType,
    nameLike: nameLike.value, // 员工姓名搜索
    page: pageHelper.value.currentPageNum, // 页数
    pageSize: pageHelper.value.pageSize, // 每页行数
    // 公海池
    isPublicPool: customerType.value,
    formId: customerType.value ? customerTemplateId.value : undefined
  }
  loading.value = true
  getAiAnalyseBusinessDataList(params)
    .then((res) => {
      customerList.value = res.result.businessDataList || []
      pageHelper.value = res.result.pageHelper
    })
    .catch(() => {})
    .finally(() => {
      loading.value = false
    })
}
onMounted(async () => {
  if (isPublicPool.value) {
    await getTheCustomerTemplateList()
  }
  toGetData()
})

onBeforeUnmount(() => {
  debouncedSearch.cancel?.()
})

const handleCurrentChange = (val) => {
  pageHelper.value.currentPageNum = val
  toGetData()
}

const onSearch = () => {
  pageHelper.value.currentPageNum = 1
  toGetData()
}

const debouncedSearch = xbb.debounce(() => {
  onSearch()
}, 400)

const handleSearchInput = () => {
  debouncedSearch()
}

const handleClearSearch = () => {
  debouncedSearch.cancel?.()
  onSearch()
}

const handleEnterSearch = () => {
  debouncedSearch.cancel?.()
  onSearch()
}

const handleRangeTypeChange = (val) => {
  rangeType.value = val
}

const handleRangeClear = () => {
  rangeValue.value = ''
  onSearch()
}

const handleSelectAll = () => {
  console.log('🚀 ~ handleSelectAll ~ handleSelectAll:', selectAllStatus.value)
  const pageList = customerList.value

  // 当前已经全选 → 取消当前页
  if (selectAllStatus.value) {
    const newList = selectCustomerList.value.filter((item) => {
      const id = item[props.modalValueAlias.key]
      return !customerListId.value.includes(id)
    })
    selectCustomerList.value.splice(0, selectCustomerList.value.length, ...newList)
  }
  // 当前未全选 → 选中当前页
  else {
    // 如果当前最大选中项超出200
    if (customerList.value.length + selectCustomerList.value.length > props.limitCount) {
      return ElMessage.warning(`超出选择数据上限制${props.limitCount}!`)
    }
    pageList.forEach((item) => {
      const id = item[props.modalValueAlias.key]
      if (!currSelectCustomerIds.value.includes(id)) {
        selectCustomerList.value.push(item)
      }
    })
  }
}

// 成员多选点击
const checkboxChange = (val) => {
  if (isCheckDisabled(val)) return
  console.log('🚀 ~ checkboxChange ~ val:', val)
  const key = props.modalValueAlias.key
  const hasIndex = selectCustomerList.value.findIndex(
    (item) => String(item[key]) === String(val[key])
  )
  if (hasIndex > -1) {
    selectCustomerList.value.splice(hasIndex, 1)
  } else {
    // // 如果当前最大选中项超出200
    // if(selectCustomerList.value.length >= props.limitCount) {
    //   return ElMessage.warning(`超出选择数据上限制${props.limitCount}!`)
    // }
    selectCustomerList.value.push(val)
  }
}

const isCheckDisabled = (val) => {
  return (
    !currSelectCustomerIds.value.includes(val.id) &&
    selectCustomerList.value.length >= props.limitCount
  )
}
// lice-cycle
onMounted(() => {})
</script>

<style lang="less" scoped>
.customer-select-content {
  box-sizing: border-box;
  padding: 16px 16px 0 0;
  height: 100%;
  display: flex;
  flex-direction: column;

  .data-list {
    margin-top: 12px;

    &__item {
      font-weight: normal;
      box-sizing: border-box;
      height: 36px;
      display: flex;
      align-items: center;
      gap: 8px;
      box-sizing: border-box;
      padding: 8px;
      border-radius: 8px;

      :deep(.el-checkbox__label) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0;
        color: #323233;
        font-size: 14px;
      }
    }
  }

  .data-empty {
    margin-top: 12px;
    width: 100%;
    text-align: center;
    color: #969799;
    font-size: 14px;
  }

  :deep(.custom-checkbox) {
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #7a52f4;
      border-color: #7a52f4;
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #7a52f4;
      border-color: #7a52f4;
    }
    .el-checkbox__input:hover .el-checkbox__inner {
      border-color: #7a52f4;
    }
  }
}
</style>
